import { govPartners } from "@/mocks/bioconData";
import { StaggerContainer, StaggerItem } from "@/components/base/StaggerContainer";

export default function GovPartners() {
  return (
    <section className="py-12 bg-white border-t border-gray-100">
      <div className="container mx-auto px-4">
        {/* Separator with text */}
        <div className="flex items-center gap-4 mb-8">
          <div className="flex-1 h-px bg-gray-200" />
          <h4 className="text-sm font-semibold text-[#2c4964] whitespace-nowrap uppercase tracking-wider">
            Government Partners
          </h4>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        <StaggerContainer className="grid grid-cols-2 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
          {govPartners.map((p) => (
            <StaggerItem key={p.id}>
              <a
                href={p.link}
                rel="nofollow"
                target="_blank"
                className="group flex items-center justify-center bg-white rounded-xl border border-gray-200/50 hover:border-[#1977cc]/20 hover:shadow-md hover:-translate-y-0.5 transition-all duration-500 w-full h-[110px] md:h-[130px] px-6 py-4"
              >
                <img
                  src={p.image}
                  alt={p.alt}
                  className="max-h-full max-w-full object-contain transition-opacity duration-500 opacity-70 group-hover:opacity-100"
                />
              </a>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}
